<app-org-appbar></app-org-appbar>

<div class="container-fluid py-3">
  @if (organizationId(); as orgId) {
    @if (isMspOrMmsp()) {
      <app-billing-summary [organizationId]="orgId"></app-billing-summary>
      <app-available-products [organizationId]="orgId"></app-available-products>
    }
    <app-active-products [organizationId]="orgId"></app-active-products>
  }
</div>
